import React from 'react';
import { Link } from 'react-router-dom';
import { Check, ArrowRight, CheckCircle2, ShoppingCart, Gauge } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { SEO } from '../components/shared/SEO';
export function ProductDIYKit() {
  const features = ['Plug-and-play electric operation (no batteries)', '75-foot hose for extended reach', 'Trigger-jet spray wand', 'Siphons directly from external containers', 'Automatic 60 PSI shutoff', 'Fully customizable mounting options'];
  return <div className="bg-white" data-id="element-484">
      <SEO title="ForceX DIY Kit | Precision Pro Sprayers" description="Build it your way. The flexible solution for contractors who want to customize their setup." data-id="element-485" />

      {/* Product Hero */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20" data-id="element-486">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-487">
          {/* Image Column */}
          <div className="bg-gray-100 rounded-xl overflow-hidden aspect-square flex items-center justify-center border border-gray-200" data-id="element-488">
            <span className="text-gray-500 font-bold text-2xl" data-id="element-489">
              [Product Image - DIY Kit]
            </span>
          </div>

          {/* Content Column */}
          <div data-id="element-490">
            <div className="mb-2" data-id="element-491">
              <span className="inline-block bg-brand-yellow/20 text-brand-dark text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-492">
                Intro Pricing Available
              </span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-brand-dark mb-4" data-id="element-493">
              ForceX – DIY Kit
            </h1>
            <p className="text-xl text-brand-yellow font-bold mb-6" data-id="element-494">
              Build it your way. Spray smarter. Move faster.
            </p>

            <div className="prose prose-lg text-gray-600 mb-8" data-id="element-495">
              <p data-id="element-496">
                The ForceX DIY Kit is designed for contractors who want
                flexibility without compromise. This plug-and-play electric
                sprayer pulls solution directly from any external
                container—eliminating pouring, lifting, and chemical spills.
              </p>
              <p className="mt-4" data-id="element-497">
                Mount the system to toolboxes, buckets, or custom setups. If it
                holds liquid, you can build a sprayer around it.
              </p>
            </div>

            <div className="bg-brand-light p-6 rounded-lg mb-8 border border-gray-200" data-id="element-498">
              <h3 className="font-bold text-brand-dark mb-4 text-lg" data-id="element-499">
                Key Features
              </h3>
              <ul className="space-y-3" data-id="element-500">
                {features.map((feature, index) => <li key={index} className="flex items-start" data-id="element-501">
                    <Check className="h-5 w-5 text-brand-yellow mr-3 mt-0.5 flex-shrink-0" data-id="element-502" />
                    <span className="text-gray-700" data-id="element-503">{feature}</span>
                  </li>)}
              </ul>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 items-center" data-id="element-504">
              <div className="text-3xl font-bold text-brand-dark" data-id="element-505">$639.99</div>
              <Link to="/contact" className="flex-grow sm:flex-grow-0" data-id="element-506">
                <Button variant="primary" size="lg" className="w-full sm:w-auto" data-id="element-507">
                  Buy Now
                </Button>
              </Link>
            </div>
            <p className="mt-4 text-sm text-gray-500" data-id="element-508">
              *First-time purchaser discounts available. Contact us for bulk
              pricing.
            </p>
          </div>
        </div>
      </div>

      {/* Tech Specs / Details Band */}
      <div className="bg-brand-dark text-white py-16" data-id="element-509">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-510">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center" data-id="element-511">
            <div className="p-4" data-id="element-512">
              <div className="text-brand-yellow font-bold text-4xl mb-2" data-id="element-513">
                60 PSI
              </div>
              <div className="text-gray-400" data-id="element-514">Automatic Shutoff</div>
            </div>
            <div className="p-4 border-y md:border-y-0 md:border-x border-gray-700" data-id="element-515">
              <div className="text-brand-yellow font-bold text-4xl mb-2" data-id="element-516">
                75 FT
              </div>
              <div className="text-gray-400" data-id="element-517">Reinforced Hose</div>
            </div>
            <div className="p-4" data-id="element-518">
              <div className="text-brand-yellow font-bold text-4xl mb-2" data-id="element-519">
                110V
              </div>
              <div className="text-gray-400" data-id="element-520">Corded Electric Power</div>
            </div>
          </div>
        </div>
      </div>

      {/* Automatic Pressure Control Explanation */}
      <section className="py-16 bg-white border-b border-gray-100" data-id="element-521">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-522">
          <div className="flex flex-col md:flex-row items-start gap-8" data-id="element-523">
            <div className="flex-shrink-0" data-id="element-524">
              <div className="w-16 h-16 bg-brand-yellow/10 rounded-full flex items-center justify-center" data-id="element-525">
                <Gauge className="h-8 w-8 text-brand-yellow" data-id="element-526" />
              </div>
            </div>
            <div data-id="element-527">
              <h2 className="text-2xl font-bold text-brand-dark mb-4" data-id="element-528">
                Automatic Pressure Control (60 PSI)
              </h2>
              <p className="text-gray-600 text-lg leading-relaxed" data-id="element-529">
                The ForceX system automatically builds pressure up to 60 PSI and
                then shuts off. When the spray trigger is squeezed, pressure is
                released and the pump automatically reactivates to restore
                pressure on demand. This ensures consistent spray performance,
                prevents over-pressurization, and reduces wear on the system.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* What's Included */}
      <section className="py-16 bg-white" data-id="element-530">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-531">
          <h2 className="text-3xl font-bold text-brand-dark mb-8" data-id="element-532">
            What's Included
          </h2>
          <div className="bg-brand-light p-8 rounded-xl border border-gray-200" data-id="element-533">
            <ul className="space-y-4" data-id="element-534">
              <li className="flex items-start" data-id="element-535">
                <CheckCircle2 className="h-6 w-6 text-brand-yellow mr-3 mt-0.5 flex-shrink-0" data-id="element-536" />
                <span className="text-gray-700 text-lg" data-id="element-537">
                  Plug-and-play electric pump
                </span>
              </li>
              <li className="flex items-start" data-id="element-538">
                <CheckCircle2 className="h-6 w-6 text-brand-yellow mr-3 mt-0.5 flex-shrink-0" data-id="element-539" />
                <span className="text-gray-700 text-lg" data-id="element-540">75-foot hose</span>
              </li>
              <li className="flex items-start" data-id="element-541">
                <CheckCircle2 className="h-6 w-6 text-brand-yellow mr-3 mt-0.5 flex-shrink-0" data-id="element-542" />
                <span className="text-gray-700 text-lg" data-id="element-543">
                  Adjustable trigger jet spray wand
                </span>
              </li>
              <li className="flex items-start" data-id="element-544">
                <CheckCircle2 className="h-6 w-6 text-brand-yellow mr-3 mt-0.5 flex-shrink-0" data-id="element-545" />
                <span className="text-gray-700 text-lg" data-id="element-546">
                  External siphon intake line
                </span>
              </li>
              <li className="flex items-start" data-id="element-547">
                <CheckCircle2 className="h-6 w-6 text-brand-yellow mr-3 mt-0.5 flex-shrink-0" data-id="element-548" />
                <span className="text-gray-700 text-lg" data-id="element-549">
                  Mounts to your own container or toolbox
                </span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Technical Specifications */}
      <section className="py-16 bg-brand-light" data-id="element-550">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-551">
          <h2 className="text-3xl font-bold text-brand-dark mb-8" data-id="element-552">
            Technical Specifications
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-553">
            <div className="bg-white p-6 rounded-lg border border-gray-200" data-id="element-554">
              <div className="font-bold text-brand-dark mb-2" data-id="element-555">Power</div>
              <div className="text-gray-600" data-id="element-556">
                Corded electric (no batteries)
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg border border-gray-200" data-id="element-557">
              <div className="font-bold text-brand-dark mb-2" data-id="element-558">Hose Length</div>
              <div className="text-gray-600" data-id="element-559">75 feet</div>
            </div>
            <div className="bg-white p-6 rounded-lg border border-gray-200" data-id="element-560">
              <div className="font-bold text-brand-dark mb-2" data-id="element-561">
                Spray Control
              </div>
              <div className="text-gray-600" data-id="element-562">Trigger-controlled wand</div>
            </div>
            <div className="bg-white p-6 rounded-lg border border-gray-200" data-id="element-563">
              <div className="font-bold text-brand-dark mb-2" data-id="element-564">Pressure</div>
              <div className="text-gray-600" data-id="element-565">Automatic shutoff at 60 PSI</div>
            </div>
            <div className="bg-white p-6 rounded-lg border border-gray-200" data-id="element-566">
              <div className="font-bold text-brand-dark mb-2" data-id="element-567">
                Intake System
              </div>
              <div className="text-gray-600" data-id="element-568">External siphon</div>
            </div>
            <div className="bg-white p-6 rounded-lg border border-gray-200" data-id="element-569">
              <div className="font-bold text-brand-dark mb-2" data-id="element-570">Applications</div>
              <div className="text-gray-600" data-id="element-571">
                Mold, disinfecting, antimicrobials, degreasers
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Contractors Choose ForceX */}
      <section className="py-16 bg-white" data-id="element-572">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-573">
          <h2 className="text-3xl font-bold text-brand-dark mb-8" data-id="element-574">
            Why Contractors Choose ForceX
          </h2>
          <div className="space-y-4" data-id="element-575">
            <div className="flex items-start p-4 bg-brand-light rounded-lg border border-gray-200" data-id="element-576">
              <CheckCircle2 className="h-6 w-6 text-brand-yellow mr-4 mt-0.5 flex-shrink-0" data-id="element-577" />
              <span className="text-gray-700 text-lg" data-id="element-578">
                No hauling chemicals into tight spaces
              </span>
            </div>
            <div className="flex items-start p-4 bg-brand-light rounded-lg border border-gray-200" data-id="element-579">
              <CheckCircle2 className="h-6 w-6 text-brand-yellow mr-4 mt-0.5 flex-shrink-0" data-id="element-580" />
              <span className="text-gray-700 text-lg" data-id="element-581">
                No pouring into backpacks or small tanks
              </span>
            </div>
            <div className="flex items-start p-4 bg-brand-light rounded-lg border border-gray-200" data-id="element-582">
              <CheckCircle2 className="h-6 w-6 text-brand-yellow mr-4 mt-0.5 flex-shrink-0" data-id="element-583" />
              <span className="text-gray-700 text-lg" data-id="element-584">
                No battery failures or downtime
              </span>
            </div>
            <div className="flex items-start p-4 bg-brand-light rounded-lg border border-gray-200" data-id="element-585">
              <CheckCircle2 className="h-6 w-6 text-brand-yellow mr-4 mt-0.5 flex-shrink-0" data-id="element-586" />
              <span className="text-gray-700 text-lg" data-id="element-587">
                Faster setup and cleanup
              </span>
            </div>
            <div className="flex items-start p-4 bg-brand-light rounded-lg border border-gray-200" data-id="element-588">
              <CheckCircle2 className="h-6 w-6 text-brand-yellow mr-4 mt-0.5 flex-shrink-0" data-id="element-589" />
              <span className="text-gray-700 text-lg" data-id="element-590">
                Cleaner, more controlled spraying
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Who It's For */}
      <section className="py-16 bg-brand-light" data-id="element-591">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-592">
          <h2 className="text-3xl font-bold text-brand-dark mb-4" data-id="element-593">
            Who It's For
          </h2>
          <p className="text-xl text-gray-600 mb-8" data-id="element-594">Ideal for:</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-595">
            {['Mold remediation professionals', 'Pest control', 'Janitorial and sanitation crews', 'Facilities maintenance teams', 'Property managers', 'Agricultural and horticultural use', 'Specialty surface treatment contractors'].map(audience => <div key={audience} className="flex items-center p-4 bg-white rounded-lg border border-gray-200" data-id="element-596">
                <CheckCircle2 className="h-5 w-5 text-brand-yellow mr-3 flex-shrink-0" data-id="element-597" />
                <span className="text-gray-700" data-id="element-598">{audience}</span>
              </div>)}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 bg-brand-dark text-white" data-id="element-599">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-600">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-601">
            Stop carrying chemicals where they don't belong.
          </h2>
          <p className="text-xl text-gray-300 mb-10" data-id="element-602">
            Spray smarter with Precision Pro Sprayers.
          </p>
          <Link to="/contact" data-id="element-603">
            <Button variant="primary" size="lg" data-id="element-604">
              <ShoppingCart className="w-5 h-5 mr-2" data-id="element-605" />
              Add to Cart
            </Button>
          </Link>
        </div>
      </section>
    </div>;
}